import { SET_STAT_TYPE } from "../types";
const INITIAL_STATE = {
  screen: "weight",
};

const StatReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_STAT_TYPE:
      return {
        ...state,
        screen: action.payload,
      };

    default:
      return state;
  }
};

export default StatReducer;
